import React from "react";
import { Link } from "react-router-dom";
import { isExternalNavUrl } from "../../lib/sitePages";

/**
 * Renders an internal React Router link or an external <a> (new tab).
 */
export default function NavItemLink({ to, children, external, onClick, className, ...rest }) {
  const href = to || "#";
  if (external || isExternalNavUrl(href)) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClick}
        className={className}
        {...rest}
      >
        {children}
      </a>
    );
  }
  return (
    <Link to={href} onClick={onClick} className={className} {...rest}>
      {children}
    </Link>
  );
}
